import styled from 'styled-components';
import { colors } from 'src/config/colors';

export const CourseListingFilterItemGroupHeader = styled.div`
  align-items: center;
  color: ${colors.blue};
  display: flex;
  font-weight: 600;
  letter-spacing: 0.15em;
  margin-top: 1.9375rem;
  margin-bottom: 1.3125rem;
  text-transform: uppercase;

  svg {
    display: block;
    flex-shrink: 0;
    margin-right: 0.75rem;
  }
`;
